// extracted by mini-css-extract-plugin
module.exports = {"root":"ColItem_root__1DNpF","label":"ColItem_label__1b0NZ","text":"ColItem_text___p6NI"};